import Vue from 'vue';
import Component from 'vue-class-component';
import * as ctpfront_pb from '@/../static/js/proto/CtpFront_pb';
import front from '@/../static/js/proto/CtpFront';
import * as ConditionData from '../../ConditionData';
import { Prop, Watch } from 'vue-property-decorator';

import * as utils from '@/utils/utils';
import * as format from '@/utils/format';
import Velocity from 'velocity-animate';
import _ from 'lodash';
/**
 * 新增条件单
 */
@Component({
  components: {},
})
export default class ConditionUpdate extends Vue {

  public arrOperation = ConditionData.con_operation;
  public arrOffset = ConditionData.offset;
  public arrDirect = ConditionData.direct;
  public arrValidTime = ConditionData.validTime;

  public showTargetSelectedKeyboard = false;
  public showTargetKeyboard = false;
  public showPriceKeyboard = false;
  public showVolumeKeyboard = false;
  public showOrderPriceKeyboard = false;
  public showFeedbackToast = false;
  public feedbackMessage = '';
  public feedbackType = 'success';
  public feedbackToastTimer = null;
  // 价格类型值
  public boardPrice: any = '';
  public tikData: any = '';
  @Prop()
  public condition: IOrderConditional;
  @Prop()
  public priceTicks;

  public formData: IOrderConditional = {
    operationType: front.con_operation_lt,
    price: '',
    offset: front.offset_open,
    direction: front.direct_buy,
    targetId: '',
    volume: '',
    validTime: front.con_validity_gfd,
    orderPrice: '',
    orderPriceType: front.con_limit_price,
    id: '',
    triggerDate: '',
    triggerTime: '',
    conditionPriceType: '',
    state: 0,
    contract: '',
  };

  public get orderPrice() {
    if (this.formData.orderPriceType === front.con_limit_price) {
      return this.formData.orderPrice;
    }
    return ConditionData.getText(
      ConditionData.con,
      this.formData.orderPriceType);
  }
  public priceValue = '';

  public get isSell() {
    return this.formData.direction === front.direct_sell;
  }

  public get themeClass() {
    return this.isSell ? 'theme-sell' : 'theme-buy';
  }

  public get validTimeOptions() {
    return [
      {
        text: '当日有效 (GFD)',
        value: front.con_validity_gfd,
      },
      {
        text: '永久有效 (GTC)',
        value: front.con_validity_all,
      },
    ];
  }

  public get orderPriceTypeOptions() {
    return [
      {
        text: '对手价',
        value: front.con_opponent_price,
      },
      {
        text: '最新价',
        value: front.con_last_price,
      },
      {
        text: '市价',
        value: front.con_market_price,
      },
      {
        text: '超一价',
        value: front.con_plusone_tick_price,
      },
      {
        text: '限价',
        value: front.con_limit_price,
      },
    ];
  }

  public get isLimitPrice() {
    return this.formData.orderPriceType === front.con_limit_price;
  }

  @Watch('tikData', { deep: true })
  public changeT(news, old) {
    this.changeBoardPrice();
  }
  @Watch('formData.orderPriceType', { deep: true })
  public changePriceType(news, old) {
    this.changeBoardPrice();
  }
  @Watch('formData.direction', { deep: true })
  public changeDirection(news, old) {
    this.changeBoardPrice();
  }
  // 价格类型变化
  public changeBoardPrice() {
    // console.log(this.formData.orderPriceType);
    this.boardPrice = 0;
    if (!this.tikData) {
      return;
    }
    if (this.formData.direction === 1) {
      switch (this.formData.orderPriceType) {
        case 16:           // 对手价
          this.boardPrice =
            this.tikData.askPrice1 ? this.tikData.askPrice1 : 0;
          break;
        case 4:            // 最新价
          this.boardPrice =
            this.tikData.latestPrice ? this.tikData.latestPrice : 0;
          break;
        case 17:           // 市价
          this.boardPrice =
            this.tikData.highStopPrice ? this.tikData.highStopPrice : 0;
          break;
        case 18:           // 超价
          this.boardPrice =
            this.tikData.bidPrice1 ? this.tikData.bidPrice1 : 0;
          break;
      }
    } else if (this.formData.direction === 2) {
      switch (this.formData.orderPriceType) {
        case 16:           // 对手价
          this.boardPrice =
            this.tikData.bidPrice1 ? this.tikData.bidPrice1 : 0;
          break;
        case 4:            // 最新价
          this.boardPrice =
            this.tikData.latestPrice ? this.tikData.latestPrice : 0;
          break;
        case 17:           // 市价
          this.boardPrice =
            this.tikData.lowStopPrice ? this.tikData.lowStopPrice : 0;
          break;
        case 18:           // 超价
          this.boardPrice =
            this.tikData.askPrice1 ? this.tikData.askPrice1 : 0;
          break;
      }
    }
    console.log(this.tikData);
  }

  public mounted() {
    this.tikData = front.subTick(this.condition.targetId, 'conditionInsert');
    _.assign(this.formData, this.condition);
    this.formData.price = format.toDoubleDigits(this.formData.price);
    this.formData.orderPrice = format.toDoubleDigits(this.formData.orderPrice);
    this.changeBoardPrice();
  }
  public beforeDestroy() {
    if (this.feedbackToastTimer) {
      clearTimeout(this.feedbackToastTimer);
      this.feedbackToastTimer = null;
    }
    if (this.condition && this.condition.targetId) {
      front.unsubTick(this.condition.targetId, 'conditionInsert');
    }
  }
  public openFeedbackToast(message, type = 'error', duration = 2000) {
    this.feedbackMessage = message;
    this.feedbackType = type;
    this.showFeedbackToast = true;
    if (this.feedbackToastTimer) {
      clearTimeout(this.feedbackToastTimer);
    }
    this.feedbackToastTimer = setTimeout(() => {
      this.showFeedbackToast = false;
      this.feedbackToastTimer = null;
    }, duration) as any;
  }
  // 增加条件单
  public addCondition() {
    if (!this.formData.targetId) {
      this.openFeedbackToast('请选择合约', 'error');
      return;
    }
    if (!this.formData.price) {
      this.openFeedbackToast('请输入价格', 'error');
      return;
    }
    if (!this.formData.volume) {
      this.openFeedbackToast('请输入手数', 'error');
      return;
    }
    if (this.formData.orderPriceType === front.con_limit_price
      && utils.isZero(this.formData.orderPrice)) {
      this.openFeedbackToast('请输入报单价', 'error');
      return;
    }
    if (this.formData.orderPriceType === 2 &&
      ((Number(this.formData.orderPrice) * 1000000) as any).toFixed(0) %
    ((this.priceTicks * 1000000) as any).toFixed(0) !== 0) {
      this.openFeedbackToast('下单价格不符合该合约的最小变动价位', 'error');
      return;
    }
    if (((Number(this.formData.price) * 1000000) as any).toFixed(0) %
    ((this.priceTicks * 1000000) as any).toFixed(0) !== 0) {
      this.openFeedbackToast('下单价格不符合该合约的最小变动价位', 'error');
      return;
    }
    front.unsubTick(this.condition.targetId, 'conditionInsert');
    const cond = new ctpfront_pb.OrderConditional();
    const data = this.formData as any as IOrderConditional;
    cond.setId(data.id);
    cond.setTargetId(data.targetId);
    cond.setPrice(parseFloat(data.price));
    cond.setConditionPriceType(front.con_last_price);
    cond.setOperationType(data.operationType);
    cond.setVolume(data.volume);
    cond.setDirection(data.direction);
    cond.setOffset(data.offset);
    cond.setValidTime(data.validTime);
    cond.setOrderPrice(parseFloat(data.orderPrice));
    cond.setOrderPriceType(data.orderPriceType);
    cond.setState(data.state);

    console.log('修改条件单', cond);

    utils.indicator('正在处理...');
    front.conditionOrderSave(cond, resolve => {
      utils.closeIndicator();
      this.openFeedbackToast('修改云条件单成功', 'success', 2200);
      console.log(resolve);
      setTimeout(() => {
        this.$emit('close');
      }, 2200);
    }, reject => {
      console.error(reject);
      utils.closeIndicator();
      this.openFeedbackToast('修改云条件单失败: ' + reject.message, 'error', 2600);
    });

  }
  public handleCancel() {
    front.unsubTick(this.condition.targetId, 'conditionInsert');
    this.$emit('close');
  }
  public selectOperation(value) {
    this.formData.operationType = value;
  }
  public selectDirection(value) {
    this.formData.direction = value;
  }
  public selectOffset(value) {
    this.formData.offset = value;
  }
  public selectValidity(value) {
    this.formData.validTime = value;
  }
  public selectOrderPriceType(value) {
    this.formData.orderPriceType = value;
    if (value === front.con_limit_price && utils.isZero(this.formData.orderPrice)) {
      const fallback = Number(this.boardPrice) || Number(this.tikData && this.tikData.latestPrice) || 0;
      if (fallback) {
        this.formData.orderPrice = format.toDoubleDigits(fallback);
      }
    }
  }
  public enter(el, done) {
    el.style.opacity = '0';
    Velocity(el,
      {
        opacity: '1',
      },
      {
        duration: 200,
        complete: done,
      });
  }
  public leave(el, done) {
    el.style.opacity = '1';
    Velocity(el,
      {
        opacity: '0',
      },
      {
        duration: 200,
        complete() {
          done();
        },
      });
  }
}



// WEBPACK FOOTER //
// ./src/views/condition/components/ConditionUpdate/ConditionUpdate.ts